import { setBodyOverflow } from '../../helpers/utils.js';

export default function ({ showAsPopup = false, open = false }) {
    return {
        showAsPopup,
        open,

        init() {
            this.setupWatchers();
            this.setupListeners();
        },

        close() {
            this.open = false;
            this.activeMobileNavElement = '';
        },

        setupListeners() {
            this.$el.addEventListener('click', ({ target }) => {
                target.classList.contains('close') && this.close();
            });
        },

        setupWatchers() {
            this.$watch('$store.mq.minWidth', () => {
                this.open = false;
                setBodyOverflow(this.open);
            });

            this.$watch('scrollAtTop', () => {
                this.close();
            });

            this.$watch('activeMobileNavElement', () => {
                if (
                    !this.activeMobileNavElement ||
                    this.activeMobileNavElement !== this.navElements.cart
                ) {
                    this.open = false;
                    return;
                }

                this.open = !this.open;
            });
        }
    };
}
